import React from 'react';

const faqs = [
  {
    question: "What makes a good book title?",
    answer: "A good book title should be memorable, reflect your book's content and genre, and appeal to your target audience. It should be unique enough to stand out while still being relevant to your subject matter."
  },
  {
    question: "How do you create a unique book title?",
    answer: "To create a unique book title, consider combining elements like themes, emotions, and key concepts from your book. Our generator helps by combining these elements with genre-specific patterns and creative variations."
  },
  {
    question: "What are popular patterns for book titles?",
    answer: "Popular patterns include 'The [Noun] of [Noun]', single powerful words, character names with descriptors, action phrases, and metaphorical titles. The best pattern depends on your genre and target audience."
  },
  {
    question: "Should my title be descriptive or creative?",
    answer: "This depends on your genre and purpose. Non-fiction titles often benefit from being more descriptive, while fiction titles can be more creative and evocative. Consider your target audience and genre conventions."
  },
  {
    question: "Can I use my generated title commercially?",
    answer: "Yes, the titles generated are free to use. However, we recommend checking for existing books with the same title and considering trademark issues before finalizing your choice."
  },
  {
    question: "How often are new titles added to the generator?",
    answer: "Our AI system continuously learns from current publishing trends and user preferences to expand its title generation capabilities, ensuring fresh and relevant suggestions."
  }
];

export default function BookFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Book Title Generator FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-purple-50 p-6 rounded-lg transform transition-all duration-300 hover:scale-[1.02]">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}